module.exports = __webpack_public_path__ + "img/txt.667f9333.png";